import React from 'react';
import { isRenu } from '../utils/ui.utils';

function SpecificSpecies(props){    
  const { s, t } = props;

  if (s.includes('RENU')) return <p>{t("species.renu.p1")}</p>;
  if (s.includes('Muscovy')) return <p>{t("species.muscovy.p1")}</p>;
  if (s.includes('Goose')) return <p>{t("species.goose.p1")}</p>;
  return <p>{t("species.duck.p1")}</p>;
}


function Species(props){  
  //use Origin + Species to display description  
  const { lotSpecies, t, changeWord } = props;
  const safeLotSpecies = lotSpecies || "";
  const isRenuProduct = isRenu(safeLotSpecies);
  
  const speciesKey = isRenuProduct ? 'renu' : 
                     (safeLotSpecies.includes('Goose') ? 'goose' : 
                     (safeLotSpecies.includes('Muscovy') ? 'muscovy' : 'duck'));
  
  const label = isRenuProduct ? t("species.renu.label") : (t(`species.types.${safeLotSpecies}`) || safeLotSpecies).toUpperCase();
  const scientific = t(`species.${speciesKey}.scientific`);
  const displaySpecies = t(`species.types.${safeLotSpecies}`) || safeLotSpecies;

  return (
    <div className="content-ac sp hide">
      <input
        className="ac-input top"
        id="ac-1afd"
        name="ac-1afd"
        data-id="2400"
        data-slug="SPECIES"
        type="checkbox"
        onChange={() => changeWord('SPECIES')}
      />
      <label className="ac-label" htmlFor="ac-1afd">{label}</label>
      <article className="ac-text ac-1afd">
        <div className="single-post-interior" tabIndex="0">
          <p className="data">{scientific}<br/>{displaySpecies}</p>
          <SpecificSpecies t={t} s={safeLotSpecies} />
        </div>
      </article>
    </div>
  );
}


export default Species;